import gql from "graphql-tag";

const professionMutations = {


    createProfession: gql`
        mutation CreateProfession($name: String, $description: String) {
            createProfession(name: $name, description: $description) {
                id,
                name,
                description
            }
        }
    `,
    updateProfession: gql`
        mutation UpdateProfession($id: ID!, $name: String, $description: String) {
            updateProfession(id: $id, name: $name, description: $description) {
                id,
                name,
                description
            }
        }
    `,
};

export default professionMutations;